import { render, staticRenderFns } from "./BillingPlans.vue?vue&type=template&id=06909172&"
import script from "./BillingPlans.vue?vue&type=script&lang=js&"
export * from "./BillingPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports